/*
 * Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
 * See LICENSE in the project root for license information.
 */

/* global document, Office, fetch, console */

const BACKEND = "https://ojx.punctuations.ai/api/v1";

Office.onReady((info) => {
  try {
    if (info.host === Office.HostType.Outlook) {
      document.getElementById("sideload-msg").style.display = "none";
      document.getElementById("app-body").style.display = "block";
      loadEmailDetails();
      document.getElementById("btn-analyse").onclick = handleAnalyse;
    }
  } catch (e) {
    console.error("Office.onReady error:", e);
  }
});

// ── Load email summary into the card ─────────────────────────────────────────

function loadEmailDetails() {
  const item = Office.context.mailbox.item;
  if (!item) return;

  document.getElementById("email-subject").textContent = item.subject || "(No subject)";

  try {
    const from = item.from;
    const name = (from && from.displayName) || "";
    const addr = (from && from.emailAddress) || "";
    document.getElementById("email-from").textContent =
      name && addr ? name + " <" + addr + ">" : addr || name || "Unknown";
  } catch (_) {
    document.getElementById("email-from").textContent = "Unknown";
  }

  item.body.getAsync(Office.CoercionType.Text, function (result) {
    if (result.status === Office.AsyncResultStatus.Succeeded) {
      document.getElementById("email-body").textContent =
        result.value.trim().substring(0, 300) || "(No body)";
    }
  });
}

// ── Step 1: Analyse — call LLM, show result ───────────────────────────────────

async function handleAnalyse() {
  var btn = document.getElementById("btn-analyse");
  btn.disabled = true;
  btn.textContent = "Analysing...";
  hideResults();
  // show("spinner");

  var item = Office.context.mailbox.item;

  item.body.getAsync(Office.CoercionType.Text, async function (result) {
    var emailBody =
      result.status === Office.AsyncResultStatus.Succeeded
        ? result.value.trim()
        : "";

    var payload = {
      subject: item.subject || "",
      from: (item.from && item.from.emailAddress) ? item.from.emailAddress : "",
      fromName: (item.from && item.from.displayName) ? item.from.displayName : "",
      body: emailBody,
      conversation_id: item.conversationId || null,
      internet_message_id: item.internetMessageId || null,
      received_at_utc: item.dateTimeCreated ? item.dateTimeCreated.toISOString() : null,
    };

    try {
      var res = await fetch(BACKEND + "/analyse", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      // hide("spinner");

      if (!res.ok) throw new Error("Server error " + res.status);
      var data = await res.json();
      console.log("Analyse response:", data);

      if (data.action === "reply") {
        renderReply(data);
      } else {
        renderTicket(data);
      }
    } catch (err) {
      // hide("spinner");
      showError(err.message);
    } finally {
      btn.disabled = false;
      btn.textContent = "Analyse Email";
    }
  });
}

// ── Step 2: Create Jira ticket ────────────────────────────────────────────────

async function handleCreateTicket(requestId) {
  var btn = document.getElementById("btn-create-ticket");
  btn.disabled = true;
  btn.textContent = "Creating...";

  try {
    var res = await fetch(BACKEND + "/create-ticket/" + requestId, {
      method: "POST",
    });

    if (!res.ok) throw new Error("Server error " + res.status);
    var data = await res.json();

    document.getElementById("ticket-key").textContent = data.jira_ticket_key;
    document.getElementById("ticket-url").href = data.jira_ticket_url;
    document.getElementById("ticket-url").textContent = data.jira_ticket_url;
    show("ticket-result");
    btn.style.display = "none";
  } catch (err) {
    showError(err.message);
    btn.disabled = false;
    btn.textContent = "Create Jira Ticket";
  }
}

// ── Render helpers ────────────────────────────────────────────────────────────

function renderReply(data) {
  document.getElementById("reply-text").textContent = data.reply_text || "";
  show("result-reply");
}

function renderTicket(data) {
  document.getElementById("ticket-title").textContent    = data.ticket_title || "";
  document.getElementById("ticket-priority").textContent = data.priority || "Medium";

  // Strip template delimiter lines (---, --, etc.) the LLM sometimes includes
  var cleanBody = (data.ticket_body || "")
    .split("\n")
    .filter(function(line) { return !/^-{2,}\s*$/.test(line.trim()); })
    .join("\n")
    .trim();

  document.getElementById("ticket-body").textContent     = cleanBody;
  document.getElementById("ticket-result").style.display = "none";

  document.getElementById("btn-create-ticket").onclick = function () {
    handleCreateTicket(data.request_id);
  };

  show("result-ticket");
}

function showError(msg) {
  document.getElementById("error-text").textContent = "Failed: " + msg;
  show("result-error");
}

function hideResults() {
  hide("result-reply");
  hide("result-ticket");
  hide("result-error");
}

function show(id) { document.getElementById(id).style.display = "block"; }
function hide(id) { document.getElementById(id).style.display = "none"; }
